import { render, staticRenderFns } from "./CreateAccountPage.vue?vue&type=template&id=7cdbd4a0&scoped=true&"
import script from "./CreateAccountPage.vue?vue&type=script&lang=js&"
export * from "./CreateAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountPage.vue?vue&type=style&index=0&id=7cdbd4a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdbd4a0",
  null
  
)

export default component.exports